import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';
import { components } from 'api/types';

type WorkflowSummary = components['schemas']['WorkflowSummary'];

function updateStateInStore(projectId: string, runId: string, summary: WorkflowSummary) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      if (!state.runsAsync.data) {
        return;
      }
      const run = state.runsAsync.data.items.find((run) => run.id === runId);
      if (run) {
        run.state = summary.state;
        if (summary.task_state_count) {
          run.task_state_count = summary.task_state_count;
        }
      }
    }),
  );
}

export default function yieldRun(runId: string) {
  const projectId = getProjectId();
  if (!projectId) return Promise.reject(new Error('No project ID'));

  return api
    .post(`projects/${projectId}/workflows/${runId}/operations`, {
      json: { type: 'YIELD' },
    })
    .json<WorkflowSummary>()
    .then(
      (summary) => {
        updateStateInStore(projectId, runId, summary);
        return summary;
      },
      (error) => {
        Sentry.captureException(error);
        throw error;
      },
    );
}
